
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 100 100","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"1.5"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#000","stroke-width":"8.33","d":"M6.237 18.488h53.57v33.673H6.237z"}}),_c('path',{attrs:{"d":"M6.237 53.214v14.543h87.526V43.823H81.576c0-20.954-3.664-26.002-24.608-25.335","fill":"none","stroke":"#000","stroke-width":"8.33"}}),_c('circle',{attrs:{"cx":"25.33","cy":"74.663","r":"6.906","fill":"none","stroke":"#000","stroke-width":"8.33"}}),_c('circle',{attrs:{"cx":"74.67","cy":"74.663","r":"6.906","fill":"none","stroke":"#000","stroke-width":"8.33"}})])
          )
        }
      }
    